import styled, {css} from "styled-components";
import { Wrapper, wrap } from 'AppReact';

const growTemplate = styled.div`
  display: flex;
  position: relative;
  flex-grow: 1;
`

const GrowWrapper = Wrapper(growTemplate);

const scrollTemplate = styled.div`
  ${({ displayState }) => css`
    flex-direction: ${displayState?.flexDirection ?? ''};
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: auto;
    background-color: white;
    display: flex;
    scrollbar-width: thin;
    scrollbar-color: #E3E3E3 transparent;

    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    ::-webkit-scrollbar-track {
      border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb {
      background: #E3E3E3;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: #E3E3E3;
    }
    
    padding: 16px 16px;
  `}
`

const ScrollWrapper = Wrapper(scrollTemplate);

export default wrap(ScrollWrapper, GrowWrapper);